import { TextInput } from "@trussworks/react-uswds";
import cn from "classnames";

// types
import { TextInputProps } from "@trussworks/react-uswds/lib/components/forms/TextInput/TextInput";

// styles
import styles from "./Input.module.scss";

type InputProps = {
  label?: string;
  rootClassName?: string;
  inputClassName?: string;
  suffix?: React.ReactNode;
} & TextInputProps;

export default function Input(props: InputProps) {
  const { label, rootClassName, inputClassName, ...rest } = props;

  const rootClasses = cn(styles["input-root"], {
    [rootClassName!]: rootClassName,
  });

  const inputClasses = cn(styles["input-wrapper"], {
    [inputClassName!]: inputClassName,
  });

  return (
    <div className={rootClasses}>
      {label && <label htmlFor={props.id}>{label}{props.suffix}</label>}
      <div className={inputClasses}>
        <TextInput {...rest} />
      </div>
    </div>
  );
}
